<!--Main Grid-->
<div class="MainGrid2Col">
	<label class="NoMargin">Student ID:</label>
	<label class="NoMargin">{{ StudentID }}</label>

	<label class="NoMargin">Student Name:</label>
	<label class="NoMargin">{{ StudentName }}</label>

	<label class="NoMargin">Date/Time:</label>
	<label class="NoMargin">{{ DateTime }}</label>

	<label class="NoMargin">Status:</label>
	<label class="NoMargin">{{ Status }}</label>

	<label class="NoMargin">Excuse:</label>
	<label class="NoMargin">{{ Excuse }}</label>

	<label class="NoMargin">Entry Type:</label>
	<label class="NoMargin">{{ EntryType }}</label>

	<label class="NoMargin">ScanStation:</label>
	<label class="NoMargin">{{ ScanStation }}</label>

	<label class="NoMargin">Modified Date:</label>
	<label class="NoMargin">{{ ModifiedDate }}</label>

	<label class="NoMargin">Modified By:</label>
	<label class="NoMargin">{{ ModifiedBy }}</label>

	<label class="NoMargin">Record Status:</label>
	<label class="NoMargin">{{ RecordStatus }}</label>

	<label class="NoMargin">Comments:</label>
	<label class="NoMargin">{{ Comments }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
